import {Box, Loading, Typography} from '@viptech/react-components'
import moment from 'moment'
import {useEffect, useState} from 'react'
import useGetTotalFromCountingFaces, {CountingFacesDTO} from 'src/hooks/api/personalized-dashboard/useGetTotalFromCountingFaces'

type Mosaico = {
  mosaico: number
  camera: number
  companyId: number
  socketCounting: CountingFacesDTO | undefined
}

type ShowCountingType = {
  cameraId: number
  total: number
  employees: number
  unique: number
}

export default function FacesCountingEventList(props: Mosaico) {
  const {mosaico, camera, companyId, socketCounting} = props

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const offset = new Date().getTimezoneOffset() / 60
  const [countingByCameras, setCountingByCameras] = useState<ShowCountingType>()

  const {data: facesCountData, isLoading: isLoadingFacesCountData} = useGetTotalFromCountingFaces({
    filter: {companyIds: [companyId], cameraIds: [camera]},
    start: moment(new Date(new Date().setHours(0, 0, 0, 0))).format(),
    end: moment(new Date(new Date().setHours(23, 59, 59, 999))).format(),
    offset,
    timeZone,
    getFrom: 'view',
  })

  useEffect(() => {
    if (!facesCountData) return
    setCountingByCameras({
      cameraId: camera,
      total: facesCountData.total,
      employees: facesCountData.employees,
      unique: facesCountData.unique,
    })
  }, [facesCountData])

  useEffect(() => {
    if (!socketCounting) return
    if (countingByCameras?.cameraId === socketCounting.cameraId) {
      setCountingByCameras((prev) => {
        return {
          total: (prev?.total ?? 0) + socketCounting.total,
          employees: (prev?.employees ?? 0) + socketCounting.employee,
          unique: (prev?.unique ?? 0) + socketCounting.unique,
          cameraId: socketCounting.cameraId,
        }
      })
    }
  }, [socketCounting])

  return (
    <Box display='flex' marginTop='20px' margin='20px 8px' position='relative' minWidth='137px'>
      {isLoadingFacesCountData ? (
        <Box position='absolute' right='4px' display='flex'>
          <Loading size='20px' />
        </Box>
      ) : (
        <Box display='flex' direction='column' rowGap='15px' justifyContent='flex-start' align='flex-start' margin='10px 8px'>
          <Typography variant='label' size={mosaico === 1 ? '16px' : '12px'}>
            <b>Total:</b> {countingByCameras?.total ?? '-'}
          </Typography>

          <Typography variant='label' size={mosaico === 1 ? '16px' : '12px'}>
            <b>Únicos:</b> {countingByCameras?.unique ?? '-'}
          </Typography>

          <Typography variant='label' size={mosaico === 1 ? '16px' : '12px'}>
            <b>Funcionários:</b> {countingByCameras?.employees ?? '-'}
          </Typography>

          <Typography variant='label' size={mosaico === 1 ? '16px' : '12px'}>
            <b>Repetidos:</b> {(countingByCameras?.total ?? 0) - (countingByCameras?.unique ?? 0) - (countingByCameras?.employees ?? 0)}
          </Typography>
        </Box>
      )}
    </Box>
  )
}
